export default "__VITE_ASSET__6171668b__"